<template>
  <v-container
    id="dashboard"
    tag="section"
  >
    <v-row
      class="d-flex"
    >
      <!--      have a location - start signup process-->
      <v-card
        flat
        v-if="hasLocation && activeSignup.id.length === 0"
        class="card-full-width"
      >
        <!--        Plans available - start signup-->
        <v-stepper
          v-if="hasPlans"
          v-model="currentStep"
          vertical
          non-linear
          class="ml-n5 pl-0 elevation-0"
        >
          <!--          Step 1 - verify location-->
          <v-stepper-step
            step="1"
            editable
          >
            Verify Location
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card
              flat
              class=""
            >
              <v-row>
                <v-col
                  cols="12"
                >
                  <div class="section-subheader">
                    Service Location
                  </div>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="calculatedStreet"
                  >
                    <template v-slot:label>
                      <div class="lbl-lg-textbox">
                        Street Address
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="6"
                >
                  <v-text-field
                    v-model="publicLocation.city"
                  >
                    <template v-slot:label>
                      <div class="lbl-lg-textbox">
                        City
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="3"
                >
                  <v-text-field
                    v-model="publicLocation.state"
                  >
                    <template v-slot:label>
                      <div class="lbl-lg-textbox">
                        State
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="3"
                >
                  <v-text-field
                    v-model="publicLocation.postal_code"
                  >
                    <template v-slot:label>
                      <div class="lbl-lg-textbox">
                        Zip
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card>
            <v-btn
              tile
              color="primary"
              @click="currentStep++"
            >
              Continue
            </v-btn>
            <v-btn text>
              Cancel
            </v-btn>
          </v-stepper-content>
          <!--          Step 2 - mark location-->
          <v-stepper-step
            step="2"
            editable
          >
            Mark and Confirm Location
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-row
              class="d-flex flex-column"
            >
              <v-card
                flat
                class="px-sm-5 mt-0 mb-6 card-full-width outline-pink"
              >
                <v-alert
                  class="px-3 section-text"
                  type="info"
                >
                  Click or tap the map to mark the roof of the location for service.
                </v-alert>
                <l-map
                  id="map"
                  ref="vwFootMap"
                  style="height: 345px; width: inherit;"
                  :zoom.sync="zoom"
                  no-blocking-animations
                  :center.sync="center"
                  @click="onMapClicked"
                >
                  <l-control-layers
                    position="topright"
                  ></l-control-layers>
                  <l-tile-layer
                    v-for="layer in tileProviders"
                    :key="layer.name"
                    :url="layer.url"
                    :visible="layer.visible"
                    :name="layer.name"
                    layer-type="base"
                  >
                  </l-tile-layer>
                  <l-marker
                    :lat-lng="locationMarker"
                    :options.sync="vwFootMarkerOptions"
                  >
                    <l-icon
                      :icon-anchor="staticAnchor"
                    >
                      <img src="https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png">
                    </l-icon>
                  </l-marker>
                </l-map>
              </v-card>
              <v-card
                v-if="errorsLocation.length > 0"
                flat
                class="mr-7 card-full-width"
              >
                <v-alert
                  type="error"
                  v-for="(e, i) in errorsLocation"
                  :key="i"
                >
                  {{ e }}
                </v-alert>
              </v-card>

              <v-card
                flat
                class="card-full-width px-4"
              >
                <v-btn
                  tile
                  color="primary"
                  @click="doSubmitConfirmLocation"
                >
                  Continue
                </v-btn>
                <v-btn text>
                  Cancel
                </v-btn>
              </v-card>
            </v-row>
          </v-stepper-content>
          <!--          Step 3 - confirm plan-->
          <v-stepper-step
            step="3"
            editable
          >
            Confirm Plan
          </v-stepper-step>
          <v-stepper-content
            step="3"
            class="px-1"
          >
            <v-slide-group
              v-model="selectedPlan"
              center-active
              show-arrows
              mandatory
              class="mx-n4 px-0"
              style="background-color: #eae8e8"
            >
              <v-slide-item
                v-for="(plan) in availablePlans"
                :key="plan.Id"
                v-slot="{ active, toggle }"
                :value="plan.Id"
                class="mx-3 outline-pink"
              >
                <v-card
                  class="px-3 d-flex flex-column"
                  style="min-height: 355px; width: 300px;"
                  @click="toggle"
                >
                  <v-card
                    flat
                    class="card-full-width text-center mt-0"
                  >
                    <span class="section-header">{{ plan.display_text }}</span>
                    <v-divider
                      class="mx-auto"
                      style="width: 85%;"
                    ></v-divider>
                  </v-card>
                  <v-card
                    flat
                    class="mx-auto mt-n1"
                    style="width: 70%"
                  >
                    <div
                      class="text-center section-subheader"
                    >
                      ${{ plan.price }}<span style="font-size: 12px">/mo</span>
                    </div>
                    <div style="font-size: .8em;">
                     Actual speeds may vary. Taxes, govt. surcharges and one-time charges apply. Service subject to availability and all applicable terms and conditions.
                    </div>
                  </v-card>
                  <v-card
                    flat
                    style="width: 85%"
                    class="mx-auto mt-0"
                  >
                    <v-row
                      v-for="(value, i) in plan.details.features"
                      :key="i"
                      class="section-bullets-sm mb-n4"
                    >
                      <v-col
                        cols="2"
                      >
                        <v-icon
                          color="success"
                          large
                        >
                          mdi-check
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="10"
                        class="justify-center"
                      >
                        {{ value }}
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card
                    class="mt-auto"
                    flat
                  >
                    <template
                      v-if="selectedPlan === plan.Id"
                    >
                      <v-btn
                        fab
                        block
                        tile
                        bottom
                        elevation="11"
                        color="success"
                        class="btn-order"
                        @click="currentStep++"
                      >
                        Confirm
                      </v-btn>
                    </template>
                    <template
                      v-else
                    >
                      <v-btn
                        fab
                        block
                        tile
                        bottom
                        elevation="11"
                        color="info"
                        class="btn-order"
                        @click="selectedPlan = plan.Id"
                      >
                        Select
                      </v-btn>
                    </template>
                  </v-card>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-stepper-content>
<!--          Questionaire-->
          <v-stepper-step
            step="4"
            editable
          >
            Gathering Details
          </v-stepper-step>
          <v-stepper-content
            step="4"
          >
            <v-form
              ref="formQuestionare"
              v-model="isQuestionareValid"
            >
              <v-row
                class="d-flex ml-2"
              >
  <!--              Location Type-->
                <v-card
                  class="px-3 mx-2 mt-1 card-question"
                >
                  <div class="section-bullets-sm">
                    Location Type:
                  </div>
                  <v-radio-group
                    v-model="questionnaireValues.locationType"
                    :rules="[rules.required]"
                  >
                    <v-radio
                      v-for="opt in signupOptLocationType"
                      :key="opt.value"
                      :value="opt.value"
                    >
                      <template v-slot:label>
                        <div class="lbl-option">
                          {{ opt.text }}
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-card>
  <!--              Floor Details-->
                <v-card
                  class="px-3 mx-2 mt-1 card-question"
                >
                  <div class="section-bullets-sm">
                    How many floors is the home or building?
                  </div>
                  <v-radio-group
                    v-model="questionnaireValues.floorDetails"
                    :rules="[rules.required]"
                  >
                    <v-radio
                      v-for="opt in signupOptLocationFloors"
                      :key="opt.value"
                      :value="opt.value"
                    >
                      <template v-slot:label>
                        <div class="lbl-option">
                          {{ opt.text }}
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-card>
  <!--              Roof Material-->
                <v-card
                  class="px-3 mx-2 mt-1 card-question"
                >
                  <div class="section-bullets-sm">
                    What is the material on the roof of the location?
                  </div>
                  <v-radio-group
                    v-model="questionnaireValues.roofMaterial"
                    :rules="[rules.required]"
                  >
                    <v-radio
                      v-for="opt in signupOptRoofMaterial"
                      :key="opt.value"
                      :value="opt.value"
                    >
                      <template v-slot:label>
                        <div class="lbl-option">
                          {{ opt.text }}
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-card>
  <!--              Square footage-->
                <v-card
                  class="px-3 mx-2 mt-1 card-question"
                >
                  <div class="section-bullets-sm">
                    What is the approximate size of the location?
                  </div>
                  <v-radio-group
                    v-model="questionnaireValues.squareFootage"
                    :rules="[rules.required]"
                  >
                    <v-radio
                      v-for="opt in signupOptSquareFootage"
                      :key="opt.value"
                      :value="opt.value"
                    >
                      <template v-slot:label>
                        <div class="lbl-option">
                          {{ opt.text }}
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-card>
  <!--              Ownership status-->
                <v-card
                  class="px-3 mx-2 mt-1 card-question"
                >
                  <div class="section-bullets-sm">
                    Ownership status?
                  </div>
                  <v-radio-group
                    v-model="questionnaireValues.ownershipStatus"
                    :rules="[rules.required]"
                  >
                    <v-radio
                      v-for="opt in signupOptOwnershipStatus"
                      :key="opt.value"
                      :value="opt.value"
                    >
                      <template v-slot:label>
                        <div class="lbl-option">
                          {{ opt.text }}
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-card>
<!--              Permission to modify-->
                <v-card
                  class="px-3 mx-2 mt-1 card-question"
                >
                  <div class="section-bullets-sm">
                    Do you have permission to modify the structure?
                  </div>
                  <v-radio-group
                    v-model="questionnaireValues.canModify"
                    :rules="[rules.mustAccept]"
                  >
                    <v-radio
                      v-for="opt in signupOptPermissionToModify"
                      :key="opt.value"
                      :value="opt.value"
                    >
                      <template v-slot:label>
                        <div class="lbl-option">
                          {{ opt.text }}
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-card>
  <!--              Permission to modify-->
                <v-card
                  class="px-3 mx-2 mt-1 card-question"
                >
                  <div class="section-bullets-sm">
                    Do you understand we will have to mount equipment to the roof or building?
                  </div>
                  <v-radio-group
                    v-model="questionnaireValues.confirmMountEquipment"
                    :rules="[rules.mustAccept]"
                  >
                    <v-radio
                      v-for="opt in signupOptConfirmMounting"
                      :key="opt.value"
                      :value="opt.value"
                    >
                      <template v-slot:label>
                        <div class="lbl-option">
                          {{ opt.text }}
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-card>
                <v-card
                  v-if="formErrors.length > 0"
                  flat
                  class="mr-7"
                >
                  <v-alert
                    type="error"
                    v-for="(e, i) in formErrors"
                    :key="i"
                  >
                    {{ e }}
                  </v-alert>
                </v-card>
                <v-card
                  v-if="errorsDetails.length > 0"
                  flat
                  class="mr-7 card-full-width"
                >
                  <v-alert
                    type="error"
                    v-for="(e, i) in errorsDetails"
                    :key="i"
                  >
                    {{ e }}
                  </v-alert>
                </v-card>
                <v-card
                  flat
                  class="card-full-width"
                >
                  <v-btn
                    tile
                    color="primary"
                    @click="doSubmitQuestions"
                  >
                    Continue
                  </v-btn>
                </v-card>
              </v-row>
            </v-form>
          </v-stepper-content>
<!--          Step 5 - Account Holder Details-->
          <v-stepper-step
            step="5"
            editable
          >
            Account Holder Details
          </v-stepper-step>
          <v-stepper-content
            step="5"
            class="px-1"
          >
            <v-form
              ref="formAccountHolder"
              v-model="isAccountHolderValid"
              class="ml-2 mr-9 px-2"
            >
              <v-row>
<!--                Account Holder Name-->
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="accountHolder.first_name"
                    label="First Name"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      <div class="lbl-header">
                        First Name
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="accountHolder.last_name"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      <div class="lbl-header">
                        Last Name
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
<!--                Mobile Phone-->
                <v-col
                  cols="12"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="accountHolder.mobile_phone"
                        counter
                      >
                        <template v-slot:label>
                          <div class="lbl-header">
                            Mobile Phone
                          </div>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="6"
                      md="3"
                    >
                      <v-text-field
                        v-model="accountHolder.mobile_phone_code"
                        placeholder="SMS Code"
                        @input="onMobileCodeChange"
                      >
                        <template v-slot:label>
                          <div class="lbl-header">
                            SMS Code
                          </div>
                        </template>
                        <template v-slot:append>
                          <v-icon
                            v-if="accountHolder.mobile_phone_verified"
                            color="success"
                          >
                            mdi-check
                          </v-icon>
                          <v-icon
                            v-else
                            color="warning"
                          >
                            mdi-alert-circle
                          </v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="6"
                      md="3"
                    >
                      <v-chip
                        v-if="accountHolder.mobile_phone_verified"
                        color="info"
                      >
                        Verified
                      </v-chip>
                      <v-btn
                        v-else
                        tile
                        color="primary"
                        @click="doRetrieveSMSCode"
                      >
                        Send SMS Code
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
<!--                Alt Phone-->
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="accountHolder.alt_phone"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      <div class="lbl-header">
                        Alternate Phone
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <!--                    Account Holder Email-->
                <v-col
                  cols="12"
                >
                  <v-row class="d-flex">
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="accountHolder.email"
                        :disabled="isLoggedIn"
                        :rules="[rules.required, rules.email]"
                        @input="onEmailChanged"
                      >
                        <template v-slot:label>
                          <div class="lbl-header">
                            Email
                          </div>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="6"
                      md="3"
                    >
                      <v-text-field
                        v-show="!isLoggedIn"
                        v-model="accountHolder.email_code"
                        :success="accountHolder.email_verified"
                        :error="!accountHolder.email_verified"
                        placeholder="Code"
                        value=""
                        @input="onEmailCodeChange"
                      >
                        <template v-slot:label>
                          <div class="lbl-header">
                            Email Code
                          </div>
                        </template>
                        <template v-slot:append>
                          <v-icon
                            v-if="accountHolder.email_verified"
                            color="info"
                          >
                            mdi-check
                          </v-icon>
                          <v-icon
                            v-else
                            color="warning"
                          >
                            mdi-alert-circle
                          </v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="6"
                      md="3"
                    >
                      <v-chip
                        v-if="accountHolder.email_verified || isLoggedIn"
                        color="info"
                      >
                        Verified
                      </v-chip>
                      <v-btn
                        v-else
                        tile
                        color="primary"
                        @click="doRetrieveEmailCode"
                      >
                        Send Email Code
                      </v-btn>
                    </v-col>
                    <v-card
                      v-if="errorsAccount.length > 0"
                      flat
                      class="mr-7 card-full-width"
                    >
                      <v-alert
                        type="error"
                        v-for="(e, i) in errorsAccount"
                        :key="i"
                      >
                        {{ e }}
                      </v-alert>
                    </v-card>
                  </v-row>
                  <v-row
                    v-if="accountHolder.is_email_unique && !isLoggedIn"
                    class="d-flex"
                  >
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="form.password"
                        :success="passwordMatch.success"
                        :error="passwordMatch.error"
                        :messages="passwordMatch.messages"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        name="input-10-1"
                        label="Password"
                        counter
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="form.confirm_password"
                        :success="passwordMatch.success"
                        :error="passwordMatch.error"
                        :messages="passwordMatch.messages"
                        type="password"
                        name="input-10-1"
                        label="Confirm Password"
                        counter
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      class="mt-n2"
                    >
                      <v-checkbox
                        v-model="form.opt_in_sms"
                        label="Opt-in to receive SMS notifications. Standard data and messaging rates may apply."
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      class="mt-n2"
                    >
                      <v-checkbox
                        v-model="form.opt_in_email"
                        label="Opt-in to receive email notifications."
                      ></v-checkbox>
                    </v-col>
                    <v-card
                      v-if="errorsAccount.length > 0"
                      flat
                      class="mr-7 card-full-width"
                    >
                      <v-alert
                        type="error"
                        v-for="(e, i) in errorsAccount"
                        :key="i"
                      >
                        {{ e }}
                      </v-alert>
                    </v-card>
                    <v-card
                      flat
                    >
                      <v-btn
                        :loading="formOverlay"
                        :disabled="formOverlay"
                        tile
                        color="primary"
                        @click="doSubmitAccountHolder"
                      >
                        Create account and continue
                      </v-btn>
                      <v-overlay :value="formOverlay">
                        <v-progress-circular
                          indeterminate
                          size="64"
                        ></v-progress-circular>
                      </v-overlay>

                    </v-card>
                  </v-row>
                  <v-row
                    v-if="!accountHolder.is_email_unique || isLoggedIn"
                    class="d-flex"
                  >
                    <v-card flat>
                      <v-btn
                        :loading="formOverlay"
                        :disabled="formOverlay"
                        tile
                        color="primary"
                        @click="doSubmitAccountHolder"
                      >
                        Continue
                      </v-btn>
                    </v-card>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-stepper-content>
          <!--          Billing details-->
          <v-stepper-step
            step="6"
            :editable="isLoggedIn"
          >
            <span class="mr-auto">
            Billing Details
            </span>
          </v-stepper-step>
          <v-stepper-content
            step="6"
          >
            <v-card
              flat
              class="card-full-width d-flex ma-0"
            >

              <v-btn
                tile
                color="secondary"
                class="ml-auto"
                @click="doCopyAccountHolder"
              >
                Copy Account Holder
              </v-btn>
            </v-card>
            <v-form
              ref="formBillingHolder"
              v-model="isBillingHolderValid"
              class="ml-2 mr-9 px-2"
            >
              <v-row>
                <!--                Billing Holder Name-->
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="billingHolder.first_name"
                    label="First Name"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      <div class="lbl-header">
                        First Name
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="billingHolder.last_name"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      <div class="lbl-header">
                        Last Name
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <!--                Mobile Phone-->
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="billingHolder.mobile_phone"
                    counter
                  >
                    <template v-slot:label>
                      <div class="lbl-header">
                        Mobile Phone
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <!--                Alt Phone-->
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="billingHolder.alt_phone"
                    counter
                  >
                    <template v-slot:label>
                      <div class="lbl-header">
                        Alternate Phone
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <!--                    Billing Holder Email-->
                <v-col
                  cols="12"
                >
                  <v-row class="d-flex">
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="billingHolder.email"
                        :rules="[rules.required, rules.email]"
                      >
                        <template v-slot:label>
                          <div class="lbl-header">
                            Email
                          </div>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
            <v-card
              v-if="errorsBilling.length > 0"
              flat
              class="mr-7 card-full-width"
            >
              <v-alert
                type="error"
                v-for="(e, i) in errorsBilling"
                :key="i"
              >
                {{ e }}
              </v-alert>
            </v-card>
            <v-card
              flat
            >
              <v-btn
                tile
                color="primary"
                @click="doSubmitAccountBilling"
              >
                Continue
              </v-btn>
            </v-card>

          </v-stepper-content>
<!--          Add-ons-->
          <v-stepper-step
            step="7"
            :editable="isLoggedIn"
          >
            Add-ons
          </v-stepper-step>
          <v-stepper-content
            step="7"
          >
            <v-form
              ref="formAddons"
              v-model="isAddonFormValid"
              class="py-0"
            >
              <v-row>
  <!--          Install Type -->
                <v-card
                  class="ml-6 mr-4 mt-1 card-full-width"
                >
                  <v-card-title>
                    <h5>Installation Type</h5>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-card
                    flat
                    class="mx-3 px-3 py-0"
                    style="text-align: left"
                  >
                    {{ businessName }}'s service uses a dish mounted external to the house that has to be brought into the structure.
                    <br />
                    The <b>Standard</b> install covers mounting to an eave or the roof and penetrating an outside wall. Our <b>Advanced</b> install covers mounting to an eave or the roof and routing the cable through an
                    attic or crawl space to install to an interior room.
                    <v-card
                      class="px-2 pt-1"
                      style="background-color: #f1eeee"
                    >
                      <div class="lbl-header">
                        Select <span style="font-weight: bold">Installation Type</span>
                      </div>
                      <v-radio-group
                        v-model="addonValues.installType"
                        :rules="[rules.required]"
                      >
                        <v-radio
                          v-for="opt in signupOptInstallType"
                          :key="opt.value"
                          :value="opt.value"
                        >
                          <template v-slot:label>
                            <div class="lbl-option">
                              {{ opt.text }} <br />
                              {{ opt.description }}
                              <br />
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-card>
                </v-card>
              </v-row>
            </v-form>
<!--            Errors-->
            <v-card
              v-if="errorsAddons.length > 0"
              flat
              class="mr-7 card-full-width"
            >
              <v-alert
                type="error"
                v-for="(e, i) in errorsAddons"
                :key="i"
              >
                {{ e }}
              </v-alert>
            </v-card>
<!--            Submit-->
            <v-card
              flat
            >
              <v-btn
                tile
                color="primary"
                @click="doSubmitAddons"
              >
                Continue
              </v-btn>
            </v-card>
          </v-stepper-content>
<!--          Summary-->
          <v-stepper-step
            step="8"
            :editable="isLoggedIn"
          >
            Finalize
          </v-stepper-step>
          <v-stepper-content
            step="8"
          >
            <v-row>
              <v-card
                flat
                class="mx-5 px-3 card-full-width"
              >
                <v-btn
                  tile
                  color="primary"
                  @click="doSubmitEzSignup"
                >
                  Submit Application
                </v-btn>
              </v-card>
            </v-row>
          </v-stepper-content>
        </v-stepper>
        <!--        No plans available-->
        <v-card
          v-else
        >
          No plans available at this location
        </v-card>
      </v-card>
<!--      signupActiveEzSignupStatus === 'requires_sig' -->
      <v-card
        v-else-if="activeSignup.id.length > 0 && signupActiveEzSignupStatus === 'requires_sig'"
        class="card-full-width pa-4"
      >
        <div class="section-subheader">
          Signup in Progress
        </div>
        <v-card
          flat
          class="card-full-width"
        >
          A signature is required to continue your signup for service. Click the button below to sign your documents.
        </v-card>
        <v-card
          flat
          class="d-flex flex-column"
        >
          <span class="mx-auto">Checking application status in {{ countdownRefresh/ countdownStepSize }}</span>
          <v-progress-linear
            v-model="countdownRefresh"
            color="blue-grey"
            height="18"
            style="width: 90%"
            class="mx-auto my-2"
          ></v-progress-linear>
          <v-divider></v-divider>
          <v-btn
            tile
            color="primary"
            style="width: 90%"
            class="mx-auto my-2"
            @click="doOpenCognito"
          >
            Sign Document
          </v-btn>
          <v-overlay :value="signupIsCheckingStatus">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>

        </v-card>
      </v-card>
<!--      All documents signed, ready to create-->
      <v-card
        v-else-if="activeSignup.id.length > 0 && signupActiveEzSignupStatus === 'signed'"
        class="card-full-width pa-4"
      >
        <div class="section-subheader">
          Almost there!
        </div>
        <v-card
          flat
          class="card-full-width section-text"
        >
          All of the required information has been provided. <strong>Click below</strong> to complete your application for service and submit it for review.
        </v-card>
        <v-card
          flat
          class="d-flex card-full-width"
        >
          <v-btn
            tile
            block
            color="primary"
            @click="doSignupConfirmSignup"
          >
            Complete Signup
          </v-btn>
        </v-card>
        <v-overlay :value="signupIsCheckingStatus">
          <v-progress-circular
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>

      </v-card>
      <v-card
        v-else
        flat
      >
        <base-tile-card>
          <template v-slot:heading>
            Location Required
          </template>

          Please return to Plans and Pricing and enter your location details.
        </base-tile-card>
      </v-card>
      <v-card
        v-if="isDebugMode"
        class="card-full-width pa-4"
      >
        <h1>Debug Mode</h1>
        <v-btn
          tile
          color="secondary"
          @click="resetSignup"
        >
          Reset Signup
        </v-btn>
        <v-btn
          tile
          color="secondary"
          @click="resetActiveSignup"
        >
          Reset Active Signup
        </v-btn>
      </v-card>
    </v-row>
  </v-container>
</template>
<style>
  .lbl-header {
    font-size: 1.1em;
    color: #505050;
  }
  .lbl-option {
    font-size: .9em;
    color: #7a7a7a;
  }
</style>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import 'leaflet/dist/leaflet.css'
  import { LControlLayers, LIcon, LMap, LMarker, LTileLayer } from 'vue2-leaflet'
  import {
    SIGNUP_GET_PLANS_AVAIL,
    PUBLIC_SEND_VERIFY_EMAIL, PUBLIC_VERIFY_EMAIL_CODE,
    PUBLIC_SEND_VERIFY_SMS, PUBLIC_VERIFY_SMS_CODE, PUBLIC_IS_EMAIL_UNIQUE,
    PUBLIC_REGISTER_USER, AUTH_LOGIN, AUTH_LOGIN_OTP, SIGNUP_SUBMIT_EZ_SIGNUP, SIGNUP_CHECK_STATUS, SIGNUP_CONFIRM_SIGNUP,
  } from '../../store/actions.types'
  import {
    SIGNUP_SET_ACCOUNT_HOLDER, SIGNUP_SET_BILLING_HOLDER, SIGNUP_SET_SELECTED_PLAN, SIGNUP_SET_FORM_STEP,
    SIGNUP_SET_LOCATION_MARKER, SIGNUP_SET_QUESTIONNAIRE_VALUES, SIGNUP_SET_ADDON_VALUES, SIGNUP_RESET_SIGNUP, SIGNUP_RESET_ACTIVE_SIGNUP,
  } from '../../store/mutations.types'

  export default {
    name: 'Signup',
    components: {
      // VueGoogleAutocomplete,
      // PowAutocompleteMap,
      'l-map': LMap,
      // 'l-geo-json': LGeoJson,
      'l-tile-layer': LTileLayer,
      'l-marker': LMarker,
      // 'l-layer-group': LLayerGroup,
      'l-control-layers': LControlLayers,
      'l-icon': LIcon,
      // 'l-wms-tile-layer': LWMSTileLayer,
      // 'l-tooltip': LTooltip,
    },
    data () {
      return {
        countdownRefresh: 100,
        countdownStepSize: 10,
        showPassword: false,
        // map variables
        zoom: 20,
        tileProviders: [
          {
            name: 'Satellite Mapbox Base',
            visible: true,
            attribution: '',
            url: 'https://api.mapbox.com/styles/v1/jdietrich/ckb86tww8021u1imi6yc0j0up/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiamRpZXRyaWNoIiwiYSI6ImNrYjdjOTY4YTA0ZGIzMHM3MDVtYW54dHMifQ.G39kMitwQre3y48CHIGhwQ',
          },
        ],
        staticAnchor: [12, 41],
        center: [37.79442939780746, -120.9921788731105],
        markerConfirmed: false,
        vwFootMarkerOptions: {
          riseOnHover: true,
        },
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          mustAccept: v => v >= 1 || 'Must accept to continue',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },
        isCheckingStatus: true,
        isQuestionareValid: false,
        isAccountHolderValid: false,
        isBillingHolderValid: false,
        isAddonFormValid: false,
        statusCheckingOverlay: false,
        formOverlay: false,
        form: {
          password: '',
          confirm_password: '',
          opt_in_sms: false,
          opt_in_email: false,
        },
        formErrors: [],
        passwordMatch: {
          error: false,
          success: false,
          messages: '',
        },
        hasError: false,
        errorsLocation: [],
        errorsPlan: [],
        errorsDetails: [],
        errorsAccount: [],
        errorsBilling: [],
        errorsAddons: [],
      }
    },
    watch: {
      accountHolder: {
        handler: function (val, oldVal) {
          console.log(val)
          this.setAccountHolder(val)
        },
        deep: true,
      },
      billingHolder: {
        handler: function (val, oldVal) {
          console.log(val)
          this.setBillingHolder(val)
        },
        deep: true,
      },
      questionnaireValues: {
        handler: function (val, oldVal) {
          console.log(val)
          this.setQuestionnaireValues(val)
        },
        deep: true,
      },
      addonValues: {
        handler: function (val, oldVal) {
          console.log(val)
          this.setAddonValues(val)
        },
        deep: true,
      },
      'form.password' (n, o) {
        console.log('form.password has changed')
        this.onPasswordChange()
      },
      'form.confirm_password' (n, o) {
        console.log('form.confirm_password has changed')
        this.onPasswordChange()
      },
    },
    computed: {
      ...mapGetters(['publicPlans', 'signupSelectedPlan', 'signupFormStep', 'signupLocationMarker',
                     'signupOptLocationType', 'signupOptLocationFloors', 'signupOptRoofMaterial',
                     'signupOptSquareFootage', 'signupOptOwnershipStatus', 'signupOptInstallType',
                     'signupOptPaymentFreq', 'signupOptPaymentMethod', 'signupOptEnrollNoWorries',
                     'signupOptAddonBridge', 'signupOptNetworkJacks', 'signupOptHeardAboutUs',
                     'signupOptPermissionToModify', 'signupOptConfirmMounting', 'isLoggedIn', 'profile',
                     'signupActiveEzSignupStatus', 'signupIsCheckingStatus', 'isDebugMode', 'businessName',
      ]),
      ...mapGetters({
        publicLocation: 'signupLocation',
        publicAvailablePlans: 'signupAvailablePlans',
        questionnaireValues: 'signupQuestionnaireValues',
        addonValues: 'signupAddonValues',
        accountHolder: 'signupAccountHolder',
        billingHolder: 'signupBillingHolder',
        activeSignup: 'signupActiveEzSignup',
      }),
      calculatedStreet: function () {
        return this.publicLocation.street_number + ' ' + this.publicLocation.route
      },
      planName: function () {
        const name = this.publicPlans.filter(p => p.value === this.selectedPlan)[0].title
        console.log('plan name: ', name)
        return name
      },
      planPrice: function () {
        const price = this.publicPlans.filter(p => p.value === this.selectedPlan)[0].price
        console.log('plan price: ', price)
        return price
      },
      installName: function () {
        try {
          const name = this.signupOptInstallType.filter(p => p.value === this.addonValues.installType)[0].text
          console.log('install name: ', name)
          return name
        } catch (e) {
          return ''
        }
      },
      installPrice: function () {
        try {
          const price = this.signupOptInstallType.filter(p => p.value === this.addonValues.installType)[0].price
          console.log('install price: ', price)
          return price
        } catch (e) {
          return 0
        }
      },
      totalMRC: function () {
        let total = 0
        total += this.planPrice
        if (this.addonValues.enrollNoWorries > 0) {
          total += 6.99
        }
        if (this.addonValues.enrollWifiUpgrade > 0) {
          total += 3.95
        }
        if (this.addonValues.addonBridge === 'rent') {
          total += 10.00
        }
        return total
      },
      totalOneTime: function () {
        let total = 0
        total += this.installPrice
        if (this.addonValues.enrollWifiUpgrade > 0) {
          total += 139.00
        }
        if (this.addonValues.addNetworkJacks && this.addonValues.addNetworkJacksQuantity > 0) {
          total += 100.00 * this.addonValues.addNetworkJacksQuantity
        }
        if (this.addonValues.addonBridge === 'purchase') {
          total += 500
        } else if (this.addonValues.addonBridge === 'rent') {
          total += 50
        }
        return total
      },
      hasLocation: function () {
        if (this.publicLocation.street_number &&
          this.publicLocation.street_number.length > 0 &&
          this.publicLocation.lat &&
          this.publicLocation.lng) {
          return true
        }
        return false
      },
      hasPlans: function () {
        if (this.hasLocation && this.availablePlans.length > 0) {
          return true
        }
        return false
      },

      availablePlans: function () {
        if (this.hasLocation) {
          return this.publicAvailablePlans
        }
        return this.publicPlans
      },
      currentStep: {
        // getter
        get: function () {
          return this.signupFormStep
        },
        // setter
        set: function (newValue) {
          this.setFormStep(newValue)
        },
      },
      billingDetails: {
        // getter
        get: function () {
          return this.billingHolder
        },
        // setter
        set: function (newValue) {
          this.setBillingHolder(newValue)
        },
      },
      selectedPlan: {
        // getter
        get: function () {
          return this.signupSelectedPlan
        },
        // setter
        set: function (newValue) {
          this.setSelectedPlan(newValue)
        },
      },
      locationMarker: {
        // getter
        get: function () {
          return this.signupLocationMarker
        },
        // setter
        set: function (newValue) {
          this.setLocationMarker(newValue)
        },
      },

    },
    async created () {
      await this.doInit()
    },
    async mounted () {
      try {
        if (this.activeSignup.rowkey && this.activeSignup.rowkey.length > 0) {
          await this.signupCheckStatus({ rowkey: this.activeSignup.rowkey })
        }
      } catch (e) {
        console.log(e)
      }

      this.countDownTimer()
      // await this.doInit()
      // setInterval(() => {
      //   if (this.isCheckingStatus) {
      //     console.log('activeSignup Params', this.activeSignup)
      //     if (this.activeSignup && this.activeSignup.rowkey && this.activeSignup.rowkey.length > 0) {
      //       this.signupCheckStatus({ rowkey: this.activeSignup.rowkey })
      //     }
      //     console.log('Checking Status')
      //   } else {
      //     console.log('Not checking status')
      //   }
      // }, 3000)
      // while (this.isCheckingStatus) {
      //   setTimeout(() => {
      //     if (this.activeSignup.id.length > 0) {
      //       console.log('Checking signup status')
      //     }
      //   }, 2000)
      // }
    },
    methods: {
      ...mapActions({
        getAvailPlans: SIGNUP_GET_PLANS_AVAIL,
        sendVerifyEmailCode: PUBLIC_SEND_VERIFY_EMAIL,
        verifyEmailCode: PUBLIC_VERIFY_EMAIL_CODE,
        sendVerifySmsCode: PUBLIC_SEND_VERIFY_SMS,
        verifySmsCode: PUBLIC_VERIFY_SMS_CODE,
        doIsEmailUnique: PUBLIC_IS_EMAIL_UNIQUE,
        doRegisterUser: PUBLIC_REGISTER_USER,
        login: AUTH_LOGIN,
        loginOtp: AUTH_LOGIN_OTP,
        submitEzSignup: SIGNUP_SUBMIT_EZ_SIGNUP,
        signupCheckStatus: SIGNUP_CHECK_STATUS,
        signupConfirmSignup: SIGNUP_CONFIRM_SIGNUP,
      }),
      ...mapMutations({
        setSelectedPlan: SIGNUP_SET_SELECTED_PLAN,
        setFormStep: SIGNUP_SET_FORM_STEP,
        setLocationMarker: SIGNUP_SET_LOCATION_MARKER,
        setAccountHolder: SIGNUP_SET_ACCOUNT_HOLDER,
        setBillingHolder: SIGNUP_SET_BILLING_HOLDER,
        setQuestionnaireValues: SIGNUP_SET_QUESTIONNAIRE_VALUES,
        setAddonValues: SIGNUP_SET_ADDON_VALUES,
        resetSignup: SIGNUP_RESET_SIGNUP,
        resetActiveSignup: SIGNUP_RESET_ACTIVE_SIGNUP,
      }),
      async doInit () {
        console.log('Initializing sign up')
        console.log('using selected plan:', this.signupSelectedPlan)
        console.log('Checking Location...')
        if (this.hasLocation && this.hasPlans) {
          console.log('we have a location lets process it', this.publicLocation)
          const loc = { ...this.publicLocation }
          console.log('loc', loc)
          loc.place_id = loc.google_place_id ? loc.google_place_id : ''
          delete loc.rowkey
          // await this.getAvailPlans(loc)
          this.center = [loc.lat, loc.lng]
          console.log('CHecking location roof marker', this.locationMarker)
          console.log('location marker is NOT set, using location')
          this.locationMarker = { lat: loc.lat, lng: loc.lng }
          this.center = [loc.lat, loc.lng]
          console.log('center pt:', this.center)
          this.zoom = 20
          // if (this.locationMarker && this.locationMarker.lat === 0 && this.locationMarker.lng === 0) {
          //   /* Potential has not marked their rooftop yet */
          // } else if (this.locationMarker && this.locationMarker.lat !== 0 && this.locationMarker.lng !== 0) {
          //   /* We have a custom location, lets use that */
          //   console.log('We have a pinned marker location, using that to center the map')
          //   this.locationMarker = { lat: this.locationMarker.lat, lng: this.locationMarker.lng }
          //   this.center = [this.locationMarker.lat, this.locationMarker.lng]
          //   this.zoom = 20
          // }
        } else if (!this.hasLocation || !this.hasPlans) {
          this.$router.push('/plans')
        }
        if (this.isLoggedIn) {
          console.log('User logged in, using email', this.profile.emailAddress)
          this.accountHolder.email = this.profile.emailAddress
          this.accountHolder.email_verified = true
          this.accountHolder.is_email_unique = false
          if (this.profile.firstName && this.profile.firstName.length > 0) {
            this.accountHolder.first_name = this.profile.firstName
          }
          if (this.profile.lastName && this.profile.lastName.length > 0) {
            this.accountHolder.last_name = this.profile.lastName
          }
          if (this.profile.mobilePhone && this.profile.mobilePhone.length > 0) {
            this.accountHolder.mobile_phone = this.profile.mobilePhone
          }
          if (this.profile.phone && this.profile.phone.length > 0) {
            this.accountHolder.alt_phone = this.profile.phone
          }
        }
      },
      async doSubmitQuestions () {
        if (await this.doVerifySectionDetails()) this.currentStep++
      },
      async doSubmitConfirmLocation () {
        if (await this.doVerifySectionLocation()) this.currentStep++
        // this.currentStep++
      },
      async doSubmitAccountHolder () {
        if (await this.doVerifySectionAccountHolder()) {
          console.log('Account holder section valid')
          console.log('User logged in:', this.isLoggedIn)
          if (this.isLoggedIn || (this.profile && this.profile.rowkey.length > 0)) {
            this.currentStep++
          }
        }
        // this.currentStep++
      },
      async doSubmitAccountBilling () {
        if (await this.doVerifySectionBilling() && this.isLoggedIn) this.currentStep++
        // this.currentStep++
      },
      async doSubmitAddons () {
        if (await this.doVerifySectionAddons() && this.isLoggedIn) this.currentStep++
        // this.currentStep++
      },
      async doCopyAccountHolder () {
        this.setBillingHolder({
          first_name: '' + `${this.accountHolder.first_name}`,
          last_name: '' + `${this.accountHolder.last_name}`,
          mobile_phone: '' + `${this.accountHolder.mobile_phone}`,
          alt_phone: '' + `${this.accountHolder.alt_phone}`,
          email: '' + `${this.accountHolder.email}`,
        })
        // this.billingHolder.first_name = '' + `${this.accountHolder.first_name}`
        // this.billingHolder.last_name = '' + `${this.accountHolder.last_name}`
        // this.billingHolder.mobile_phone = '' + `${this.accountHolder.mobile_phone}`
        // this.billingHolder.alt_phone = '' + `${this.accountHolder.alt_phone}`
        // this.billingHolder.email = '' + `${this.accountHolder.email}`
      },
      async doVerifySectionLocation () {
        this.errorsLocation = []
        console.log('Verifying Section: Location')
        if (this.hasLocation) {
          if (this.locationMarker.lat === this.publicLocation.lat && this.locationMarker.lng === this.publicLocation.lng) {
            this.errorsLocation.push('You must mark the map by clicking or tapping the roof nearest.')
          }
        } else {
          this.errorsLocation.push('You must look up your address before submitting the application')
        }
        return this.errorsLocation.length === 0
      },
      async doVerifySectionPlan () {
        console.log('Verifying Section: Plan')
        this.errorsPlan = []
        if (!this.selectedPlan) {
          this.errorsPlan = 'You must select a plan before you can proceed.'
        }
        return this.errorsPlan.length === 0
      },
      async doVerifySectionDetails () {
        console.log('Verifying Section: Details')
        this.errorsDetails = []
        const validForm = this.$refs.formQuestionare.validate()
        console.log(validForm)
        if (this.questionnaireValues.canModify < 1) {
          this.errorsDetails.push('You must be able to modify the location to mount equipment.')
        }
        if (this.questionnaireValues.confirmMountEquipment < 1) {
          this.errorsDetails.push('You have to agree that we can mount equipment to the location if required including the roof.')
        }
        return (validForm && this.errorsDetails.length === 0)
      },
      async doVerifySectionAccountHolder () {
        console.log('Verifying Section: Account Holder')
        this.errorsAccount = []
        const validForm = this.$refs.formAccountHolder.validate()
        console.log('form valid?', validForm)
        if (!validForm) {
          this.errorsAccount.push('Please correct any fields marked above')
        }
        if (this.validateEmail(this.accountHolder.email)) {
          if (!this.accountHolder.email_verified && !this.isLoggedIn) {
            this.errorsAccount.push('Email address must be verified. Please check your email for a verification code.')
            await this.doRetrieveEmailCode()
          }
        } else {
          this.errorsAccount.push('Email address must be a valid email. Please correct the email.')
        }
        if (this.accountHolder.is_email_unique) {
          if (this.form.password.length < 8) {
            this.errorsAccount.push('Passwords must be at least 8 characters long.')
            this.passwordMatch.error = true
            this.passwordMatch.success = false
            this.passwordMatch.messages = 'Passwords must be at least 8 characters long.'
          } else {
            this.onPasswordChange()
            if (!this.passwordMatch.success) {
              this.errorsAccount.push('Passwords must match.')
            }
          }
        }
        if (this.errorsAccount && this.errorsAccount.length === 0) {
          if (this.accountHolder.is_email_unique && !this.isLoggedIn) {
            await this.doRegister()
          } else if (!this.isLoggedIn) {
            await this.doLoginOtp()
          }
        }
        return this.errorsAccount.length === 0
      },
      async doVerifySectionBilling () {
        console.log('Verifying Section: Billing Holder')
        const validForm = this.$refs.formBillingHolder.validate()
        console.log('Billing form valid:', validForm)
        return validForm
      },
      async doVerifySectionAddons () {
        console.log('Verifying Section: Addon Options')
        this.errorsAddons = []
        const validForm = this.$refs.formAddons.validate()
        console.log('Addon form valid:', validForm)
        if (!validForm) {
          this.errorsAddons.push('Please correct any fields marked above')
        }
        return validForm
      },
      async doValidateSignup () {
        const forms = ['formQuestionare', 'formAccountHolder', 'formBillingHolder', 'formAddons']
        console.log(forms)
      },
      async doSignupConfirmSignup () {
        this.signupConfirmSignup({ rowkey: this.activeSignup.rowkey })
      },
      async doLogin () {
        console.log('doing login!')
        await this.login({ email_address: this.accountHolder.email, password: this.form.password })
      },
      async doLoginOtp () {
        console.log('doing login!')
        const loginSuccess = await this.loginOtp({ contact: this.accountHolder.email, password: this.accountHolder.email_code })
        if (!loginSuccess) {
          this.accountHolder.email_code = ''
          this.accountHolder.email_verified = false
          this.errorsAccount.push('Failed to authenticate the email code.')
        }
      },
      async doRegister () {
        this.formOverlay = true
        console.log('doing register!')
        try {
          const payload = {
            email_address: this.accountHolder.email,
            password: this.form.password,
            first_name: this.accountHolder.first_name,
            last_name: this.accountHolder.last_name,
            mobile_number: this.accountHolder.mobile_phone,
            mobile_status: this.accountHolder.mobile_phone_verified ? 'confirmed' : 'unconfirmed',
            opt_in_sms: this.form.opt_in_sms,
            opt_in_email: this.form.opt_in_email,
            code_mail: this.accountHolder.email_code,
          }
          const data = await this.doRegisterUser(payload)
          if (data && data.rowkey) {
            this.doLogin()
          }
        } catch (e) {

        }
        this.formOverlay = false
      },

      async doRetrieveSMSCode () {
        const result = await this.sendVerifySmsCode({ contact: this.accountHolder.mobile_phone })
        if (result.code && result.code.length > 0) {
          alert(`A SMS has been sent to ${this.accountHolder.mobile_phone}`)
        } else {
          alert(`An error occured when sending a SMS to ${this.accountHolder.mobile_phone}`)
        }
      },
      async doRetrieveEmailCode () {
        const result = await this.sendVerifyEmailCode({ contact: this.accountHolder.email })
        if (result.code && result.code.length > 0) {
          alert(`An email has been sent to ${this.accountHolder.email}`)
        } else {
          alert(`An error occured when sending an email to ${this.accountHolder.email}`)
        }
      },
      async doSubmitEzSignup () {
        const validLocation = await this.doVerifySectionLocation()
        const validPlan = await this.doVerifySectionPlan()
        const validDetails = await this.doVerifySectionDetails()
        const validAccountHolder = await this.doVerifySectionAccountHolder()
        const validBilling = await this.doVerifySectionBilling()
        const validAddons = await this.doVerifySectionAddons()
        console.log('Valid Location', validLocation)
        console.log('Valid Plan', validPlan)
        console.log('Valid Details', validDetails)
        console.log('Valid Account Holder', validAccountHolder)
        console.log('Valid Billing', validBilling)
        console.log('Valid Add-ons', validAddons)
        const formData = {}
        formData.selectedPlan = this.selectedPlan
        formData.accountHolder = { ...this.accountHolder }
        formData.location = { ...this.publicLocation }
        formData.locationMarker = { ...this.locationMarker }
        formData.billingHolder = { ...this.billingHolder }
        formData.questionnaireValues = { ...this.questionnaireValues }
        formData.addonValues = { ...this.addonValues }
        console.log(formData)
        await this.submitEzSignup(formData)
      },
      async doOpenCognito () {
        const cognitoPayload = {
          Name: {
            First: `${this.accountHolder.first_name}`,
            Last: `${this.accountHolder.last_name}`,
          },
          ServiceAddress: {
            City: `${this.publicLocation.city}`,
            Line1: `${this.publicLocation.formatted_address}`,
            PostalCode: `${this.publicLocation.postal_code}`,
          },
          Phone: `${this.accountHolder.mobile_phone}`,
          Email: `${this.accountHolder.email}`,
          PrintedName: `${this.accountHolder.first_name} ${this.accountHolder.last_name}`,
          ApplicationCode: this.activeSignup.rowkey,
          UserKey: this.profile.rowkey,
        }
        // requestforinstall
        // const cognitoUrl = `https://www.cognitoforms.com/VelociterWireless/aupcsa?entry=${JSON.stringify(cognitoPayload)}`
        // const cognitoUrl = `https://www.cognitoforms.com/VelociterWireless/requestforinstall?entry=${JSON.stringify(cognitoPayload)}`
        const cognitoUrl = `https://www.cognitoforms.com/VelociterWireless/requestforinstallationpackage2?entry=${JSON.stringify(cognitoPayload)}`
        console.log(cognitoUrl)
        window.location.href = cognitoUrl
      },
      async onMapClicked (event) {
        // console.log('map clicked event')
        // console.log(event)
        // this.locationMarker.lat = event.latlng.lat
        // this.locationMarker.lng = event.latlng.lng
        this.locationMarker = { lat: event.latlng.lat, lng: event.latlng.lng }
      },
      async onMobileCodeChange (event) {
        console.log(event)
        const payload = { contact: this.accountHolder.mobile_phone, code: event }
        const resp = await this.verifySmsCode(payload)
        // eslint-disable-next-line camelcase
        const { code } = resp
        // eslint-disable-next-line camelcase
        this.accountHolder.mobile_phone_verified = code === event
        console.log(resp)
      },
      async onEmailChanged (event) {
        console.log(event)
        const isUnique = await this.doIsEmailUnique({ email_address: event })
        this.accountHolder.is_email_unique = isUnique
        this.accountHolder.email_verified = false
      },
      async onEmailCodeChange (event) {
        console.log(event)
        const payload = { contact: this.accountHolder.email, code: event }
        const resp = await this.verifyEmailCode(payload)
        // eslint-disable-next-line camelcase
        const { code } = resp
        // eslint-disable-next-line camelcase
        this.accountHolder.email_verified = code === event
        console.log(resp)
      },
      onPasswordChange () {
        if (this.form.password === this.form.confirm_password) {
          this.passwordMatch.error = false
          this.passwordMatch.success = true
          this.passwordMatch.messages = []
        } else {
          this.passwordMatch.error = true
          this.passwordMatch.success = false
          this.passwordMatch.messages = 'Passwords must match'
        }
      },
      validateEmail (email) {
        // eslint-disable-next-line no-useless-escape
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(email).toLowerCase())
      },
      countDownTimer () {
        try {
          if (this.countdownRefresh >= 0) {
            setTimeout(() => {
              this.countdownRefresh -= this.countdownStepSize
              this.countDownTimer()
            }, 1000)
          } else if (this.countdownRefresh <= 0) {
            if (this.isCheckingStatus && this.signupActiveEzSignupStatus !== 'signed') {
              console.log('activeSignup Params', this.activeSignup)
              if (this.activeSignup && this.activeSignup.rowkey && this.activeSignup.rowkey.length > 0) {
                this.signupCheckStatus({ rowkey: this.activeSignup.rowkey })
              }
              console.log('Checking Status')
            } else {
              console.log('Not checking status')
            }
            this.countdownRefresh = 100
            this.countDownTimer()
          } else {
            this.countdownRefresh = 100
            this.countDownTimer()
          }
        } catch (e) {
          this.countdownRefresh = 100
          this.countDownTimer()
        }
      },
    },
  }
</script>
<style>
  .div-glow {
    box-shadow: 0 20px 20px -17px rgba(0,255,255,0.53);
  }
  .card-question {
    width: 300px;
  }
</style>
